<template>
  <a-card :bordered="false" :bodyStyle="{padding:'20px'}" :headStyle="{borderBottom:'0px',paddingLeft:'20px'}">
    <a-row slot="title">
      <a-col :span="8">
        <span class="card-title">友情链接设置</span>
      </a-col>
      <a-col :span="8" :offset="8" style="text-align:right;">
        <a-button type="primary" @click="handleContent(0)">添加新内容</a-button>
      </a-col>
    </a-row>
    <custom-paging-dragging-list
      ref="table"
      rowKey="id"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
      @draggable="onDraggable"
    >
      <div slot="indexSlots" slot-scope="rowItem">{{ rowItem.index + 1 }}</div>
      <template slot="contentSlots" slot-scope="rowItem">
        链接
      </template>
      <div slot="action" slot-scope="rowItem">
        <a @click="handleContent(rowItem.record.id)">编辑</a>
        <a-divider type="vertical"/>
        <a-popconfirm
          title="你确定要删除这行内容吗?"
          @confirm="deleteEvent(rowItem.record)">
          <a-icon slot="icon" type="close-circle" style="color: red"/>
          <a>删除</a>
        </a-popconfirm>
      </div>
    </custom-paging-dragging-list>
  </a-card>
</template>

<script>
import CustomPagingDraggingList from '@/customComponents/CustomPagingDraggingList/CustomPagingDraggingList'

export default {
  name: 'FriendlyLink',
  components: {
    CustomPagingDraggingList
  },
  data() {
    return {
      columns: [
        {
          title: '排序',
          dataIndex: 'index',
          scopedSlots: { customRender: 'indexSlots' },
          width: '70px'
        },
        {
          title: '文字',
          width: '40%',
          dataIndex: 'title'
        },
        {
          title: '内容类型',
          dataIndex: 'modularContentType',
          scopedSlots: { customRender: 'contentSlots' }
        },
        {
          title: '修改时间',
          dataIndex: 'gmtModified'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '90px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      loadPromise: params => this.getListPromise(params),
      queryParams: {}
    }
  },
  activated() {
    this.$refs.table.refresh(true)
  },
  methods: {
    handleContent(id) {
      let params = {}
      if (id) {
        params.id = id
      }
      this.openNewPage('AddLink', params)
    },
    // 删除
    deleteEvent(item) {
      this.getHttpServices().getUserService().post('pc/v2/friendship-link/delete/' + item.id)
        .then(res => {
          this.$refs.table.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 拖拽排序功能
    onDraggable(params) {
      let idList = []
      idList = params.dataList.map((item) => {
        return item.id
      })
      this.getHttpServices().getUserService().post('pc/v2/friendship-link/orderBy', {
        pageNum: params.pageNo,
        pageSize: params.pageSize,
        idList: idList
      }).then(res => {
        this.$message.success('排序成功')
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getListPromise(params) {
      return this.getHttpServices().getUserService().post('pc/v2/friendship-link/query', params)
    }
  }
}
</script>

<style lang="less">
</style>